module.exports = __webpack_public_path__ + "static/media/lcyhm.1dfd4dce.png";